export default __webpack_public_path__ + "static/media/leftQuote.24609303.svg";